import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDIz84nf481cVG4DK3ih7EC6AShJl9OEF0",
    authDomain: "hangman-3377d.firebaseapp.com",
    databaseURL: "https://hangman-3377d.firebaseio.com",
    projectId: "hangman-3377d",
    storageBucket: "hangman-3377d.appspot.com",
    messagingSenderId: "866815542448"
});

const auth = firebaseApp.auth();
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js